import React from 'react'

import SendImage from '../../images/send.png'
import SmilyImage from '../../images/smily.svg'

function MessageInput({ text, setText, sendMessage, setShowPicker }) {
    const handleSend = e => {
        e.preventDefault()

        const trimmed = text.trim()
        if (!trimmed) return

        sendMessage(trimmed)
        setText('')
    }

    return (
        <div
            style={{
                display: 'flex',
                borderTop: '1px solid #E4ECF8',
                paddingTop: '1rem',
                paddingLeft: '1rem',
                paddingRight: '1rem',
                backgroundColor: 'white',
            }}
        >
            <form
                onSubmit={handleSend}
                style={{
                    backgroundColor: '#E4ECF8',
                    padding: '0.75rem 1rem',
                    display: 'flex',
                    alignItems: 'center',
                    flexGrow: 1,
                    borderRadius: '0.375rem',
                }}
            >
                <input
                    placeholder="Enter Message..."
                    value={text}
                    onChange={e => setText(e.target.value)}
                    style={{
                        width: '100%',
                        outline: 'none',
                        backgroundColor: 'transparent',
                        border: 'none',
                        fontSize: '0.875rem',
                    }}
                />

                <button
                    type="button"
                    onClick={() => setShowPicker(val => !val)}
                    style={{
                        marginLeft: '0.75rem',
                        border: 'none',
                        backgroundColor: 'transparent',
                        padding: 0,
                        cursor: 'pointer',
                    }}
                >
                    <img src={SmilyImage} alt="Emoji" style={{ width: '1rem', height: '1rem' }} />
                </button>

                <button
                    type="submit"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginLeft: '0.75rem',
                        backgroundColor: '#23426e',
                        padding: '0.75rem 1rem',
                        borderRadius: '0.375rem',
                        border: 'none',
                        cursor: 'pointer',
                    }}
                >
                    <img src={SendImage} alt="Send" style={{ width: '1rem', height: '1rem' }} />
                </button>
            </form>
        </div>
    )
}

export default MessageInput
